import { Component, OnInit, OnDestroy } from '@angular/core';

import {
  ASSIGNMENT_METHOD,
  SELECTED_USER_TYPE,
} from '../manage-access.constant';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription, combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { RouterFacade } from '@cigna/core/router-state';

@Component({
  selector: 'cigna-page-choose-assignment-method',
  templateUrl: './page-choose-assignment-method.component.html',
  styleUrls: ['./page-choose-assignment-method.component.scss'],
})
export class PageChooseAssignmentMethodComponent implements OnInit, OnDestroy {
  constructor(
    private manageAccessFacade: ManageUserAccessFacade,
    private formBuilder: FormBuilder,
    private router: Router,
    private routerFacade: RouterFacade,
    private activatedRoute: ActivatedRoute,
  ) {}

  assignTypeForm: FormGroup;

  ASSIGNMENT_METHOD_INDIVIDUAL = ASSIGNMENT_METHOD.individual;
  USER_TYPE_EXISTING = SELECTED_USER_TYPE.exisiting;

  entitlementsLoaded$ = this.manageAccessFacade
    .selectedUsersEntitlementsLoaded$;
  hiddenSteps$ = this.manageAccessFacade.hiddenSteps$;
  steps$ = this.manageAccessFacade.steps$;
  userType$ = this.manageAccessFacade.selectedUserType$;
  assignmentMethod$ = this.manageAccessFacade.assignmentMethod$;
  allTinsLoaded$ = this.manageAccessFacade.allTinsLoaded$;
  queryParams$ = this.routerFacade.queryParams$;

  assignmentSubscrition: Subscription;

  ngOnInit() {
    this.manageAccessFacade.getAllWamTins();
    this.assignTypeForm = this.formBuilder.group({
      accessType: this.ASSIGNMENT_METHOD_INDIVIDUAL,
    });

    this.assignmentSubscrition = combineLatest([
      this.userType$,
      this.assignmentMethod$,
      this.queryParams$,
    ])
      .pipe(take(1))
      .subscribe(([type, method, queryParams]) => {
        if (queryParams && queryParams.users) {
          this.manageAccessFacade.loadUsersFromDashboard(
            queryParams.users.split(','),
          );
          this.manageAccessFacade.loadDelegationData();
        } else {
          this.assignTypeForm.patchValue({ accessType: method });
          if (type === this.USER_TYPE_EXISTING) {
            this.manageAccessFacade.loadUsersEntitlements();
          }
        }
      });
  }

  ngOnDestroy() {
    this.assignmentSubscrition.unsubscribe();
  }

  previousScreen(): void {
    this.router.navigate(['../new'], { relativeTo: this.activatedRoute });
  }

  nextScreen(): void {
    this.manageAccessFacade.setAssignMethodAndProceed(
      this.assignTypeForm.value.accessType,
    );
    this.manageAccessFacade.triggerUserScaffolding();
  }
}
